import { createStore } from 'vuex'
import axios from 'axios'
import {login} from '../store/modules/login'
import {nic} from '../store/modules/nic'

export default createStore({
  state: {
    v_categories:[
        {
            id:1,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
            type:'food'
        },
        {
            id:2,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
            type:'food'
        },
        {
            id:3,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:4,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
            type:'food'
        },
        {
            id:5,
            title:'cargando',
            lang:'es',
            type:'food'
        },
        {
            id:6,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
            type:'food'
        },
        {
            id:7,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:8,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:9,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:10,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:11,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:12,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:13,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:14,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
    
        {
            id:15,
            title:'cargando',
            lang:'es',
            menu:1,
            enabled:1,
        },
        {
            id:16,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:17,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:18,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:19,
            title:'cargando',
            lang:'en'
        },
        {
            id:20,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:21,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:22,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:23,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:24,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:25,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:26,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:27,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:28,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        {
            id:29,
            title:'cargando',
            lang:'en',
            menu:1,
            enabled:1,
        },
        
    ],
    v_url_global:'https://backboomdeli.tusistema.online/api',//'https://backboomdeli.tusistema.online/api'//'http://127.0.0.1:8000/api'
    v_url_photo:'https://backboomdeli.tusistema.online',//'https://backboomdeli.tusistema.online'//'http://127.0.0.1:8000'
    v_allergens_es:[
      {
          id:1,
          toggle:false,
          allergen:true,
          name: "Gluten",
          icon_name:"gluten",
          description: "Cereales que contengan gluten",
          derivatives:[
              {name:'Trigo (como trigo espelta y trigo khorasan).'},
              {name:'Centeno.'},
              {name:'Cebada.'},
              {name:'Avena o sus variedades híbridas.'},
              {name:'Productos derivados.'},
          ],
          exception:'Jarabes de glucosa a base de trigo, incluida la dextrosa, maltodextrinas a base de trigo, jarabes de glucosa a base de cebada, cereales utilizados para hacer destilados alcohólicos, incluido el alcohol etílico de origen agrícola.'
      },
      {
          id:2,
          toggle:false,
          allergen:true,
          name: "Mani",
          icon_name:"mani",
          description: "MANI(CACAHUATE) Y PRODUCTOS A BASE DE MANI",
          derivatives:[
              {name:'Todas las variedades de maní y productos a base del mismo.'}],
          exception:null,
      },
       {
          id:3,
          toggle:false,
          allergen:true,
          name: "Soja",
          icon_name:"soja",
          description: "Soja(soya) y productos a base de soja",
          derivatives:[
              {name:'Todas las variedades de soya y productos a base de la misma.'}],
          exception:'A excepción: aceite y grasa de semilla de soja totalmente refinados, tocoferoles naturales mezclados (E306), d-alfa tocoferol natural, acetato de d-alfa tocoferol natural y succinato de d-alfa tocoferol natural derivados de la soja, fitosteroles y ésteres de fitosterol derivados de aceites vegetales de soja, ésteres de fitostanol derivados de fitosteroles de aceite de semilla de soja. ',
      },
      {
          id:4,
          toggle:false,
          allergen:true,
          name: "Nuez",
          icon_name:"nuez",
          description: "Frutos cáscara",
          derivatives:[
              {name:'Almendras.'},
              {name:'Avellanas.'},
              {name:'Nueces.'},
              {name:'Anacardos.'},
              {name:'Pecanas.'},
              {name:'Nueces de Brasil.'},
              {name:'Pistachos.'},
              {name:'Productos derivados.'},
              ],
          exception:'A excepción:  frutos de cáscara utilizados para hacer destilados alcohólicos, incluido el alcohol etílico de origen agrícola.',
      },
      {
          id:5,
          toggle:false,
          allergen:true,
          name: "Apio",
          icon_name:"apio",
          description: "Apio y productos derivados",
          derivatives:[
              {name:'Todas las variedades de apio y productos a base del mismo.'},
              ],
          exception:null,
      },
      {
          id:6,
          toggle:false,
          allergen:true,
          name: "Mostaza",
          icon_name:"mostaza",
          description: "Mostaza y productos derivados",
          derivatives:[
              {name:'Todas las variedades de mostaza y productos a base del mismo.'},
              ],
          exception:null,
      },
      {
          id:7,
          toggle:false,
          allergen:true,
          name: "Sésamo",
          icon_name:"sesamo",
          description: "Granos de sésamo y productos a base de granos de sésamo",
          derivatives:[
              {name:'Todas las variedades de sésamo y productos a base del mismo.'},
              ],
          exception:null,
      },
      {
          id:8,
          toggle:false,
          allergen:true,
          name: "Dióxido de azufre y sulfitos",
          icon_name:"e-x",
          description: "Dióxido de azufre y sulfitos",
          derivatives:[
              {name:'Todas las variedades de dióxido de azufre y sulfitos  y productos a base del mismo.'},
              ],
          exception:null,
      },
        {
          id:9,
          toggle:false,
          allergen:true,
          name: "Altramuces",
          icon_name:"altramuces",
          description: "Altramuces o lupinos y produtos a base de estos",
          derivatives:[
              {name:'Todas las variedades de altramuces o lupinos (se encuentran dentro de la categoría de las legumbres) y productos a base del mismo.'},
              ],
          exception:null,
      },
      {
          id:10,
          toggle:false,
          allergen:false,
          name: "Hongos",
          icon_name:"hongo",
          description: "Hongos comestibles",
          derivatives:[
              {name:'Hongos ostra.'},
              {name:'Hongos Champiñon.'},
              {name:'Hongos shiitake.'},
              ],
          exception:null,
      },
      {
          id:11,
          toggle:false,
          allergen:false,
          name: "Ají",
          icon_name:"aji",
          description: "ají",
          derivatives:[
              {name:'Todas las variedades de ají.'},
              ],
          exception:null,
      },
      {
          id:12,
          toggle:false,
          allergen:false,
          name: "Algas",
          icon_name:"algas",
          description: "Algas",
          derivatives:[
              {name:'Todas las variedades de algas.'},
              ],
          exception:null,
      },
      {
          id:13,
          toggle:false,
          allergen:false,
          name: "Leche de coco",
          icon_name:"leche-coco",
          description: "Leche de coco",
          derivatives:[
              {name:'Todas las variedades de leche de coco.'},
              ],
          exception:null,
      },

    ],
    v_allergens_en:[
      {
          id:1,
          toggle:false,
          allergen:true,
          name: "Gluten",
          icon_name:"gluten",
          description: "Cereals containing gluten",
          derivatives:[
              {name:'Wheat (such as spelled and khorasan wheat).'},
              {name:'Rye.'},
              {name:'Barley.'},
              {name:'Oats or their hybrid varieties.'},
              {name:'Derived products.'},
          ],
          exception:'Jarabes de glucosa a base de trigo, incluida la dextrosa, maltodextrinas a base de trigo, jarabes de glucosa a base de cebada, cereales utilizados para hacer destilados alcohólicos, incluido el alcohol etílico de origen agrícola.'
      },
      {
          id:2,
          toggle:false,
          allergen:true,
          name: "Peanut",
          icon_name:"mani",
          description: "PEANUTS AND PEANUT-BASED PRODUCTS",
          derivatives:[
              {name:'All varieties of peanuts and products based on it.'}],
          exception:null,
      },
      {
          id:3,
          toggle:false,
          allergen:true,
          name: "Soy",
          icon_name:"soja",
          description: "Soy and soy-based products",
          derivatives:[
              {name:'All varieties of soy and products based on it.'}],
          exception:'A excepción: aceite y grasa de semilla de soja totalmente refinados, tocoferoles naturales mezclados (E306), d-alfa tocoferol natural, acetato de d-alfa tocoferol natural y succinato de d-alfa tocoferol natural derivados de la soja, fitosteroles y ésteres de fitosterol derivados de aceites vegetales de soja, ésteres de fitostanol derivados de fitosteroles de aceite de semilla de soja. ',
      },
      {
          id:4,
          toggle:false,
          allergen:true,
          name: "Nut",
          icon_name:"nuez",
          description: "dried fruits",
          derivatives:[
              {name:'Almonds.'},
              {name:'Hazelnuts.'},
              {name:'Walnuts.'},
              {name:'Cashew nuts.'},
              {name:'Pecans.'},
              {name:'Brazil nuts.'},
              {name:'Pistachios.'},
              {name:'Derived products.'},
              ],
          exception:'A excepción:  frutos de cáscara utilizados para hacer destilados alcohólicos, incluido el alcohol etílico de origen agrícola.',
      },
      {
          id:5,
          toggle:false,
          allergen:true,
          name: "Celery",
          icon_name:"apio",
          description: "Celery and derived products",
          derivatives:[
              {name:'All varieties of celery and products based on it.'},
              ],
          exception:null,
      },
      {
          id:6,
          toggle:false,
          allergen:true,
          name: "Mustard",
          icon_name:"mostaza",
          description: "Mustard and derived products",
          derivatives:[
              {name:'All varieties of mustard and products based on it.'},
              ],
          exception:null,
      },
      {
          id:7,
          toggle:false,
          allergen:true,
          name: "Sesame",
          icon_name:"sesamo",
          description: "Sesame grains and sesame grain products",
          derivatives:[
              {name:'All varieties of sesame and products based on it.'},
              ],
          exception:null,
      },
      {
          id:8,
          toggle:false,
          allergen:true,
          name: "Sulfur dioxide and sulphites",
          icon_name:"e-x",
          description: "Sulfur dioxide and sulphites",
          derivatives:[
              {name:'All varieties of sulfur dioxide and sulphites and products based on the same.'},
              ],
          exception:null,
      },
      {
          id:9,
          toggle:false,
          allergen:true,
          name: "Lupins",
          icon_name:"altramuces",
          description: "lupinis beans and products based on these",
          derivatives:[
              {name:'All varieties of lupinis beans (found within the category of legumes) and products based on it.'},
              ],
          exception:null,
      },
      {
          id:10,
          toggle:false,
          allergen:false,
          name: "Mushrooms",
          icon_name:"hongo",
          description: "Edible mushrooms",
          derivatives:[
              {name:'Mushrooms.'},
              {name:'Oyster mushrooms.'},
              {name:'Shiitake mushrooms.'},
              ],
          exception:null,
      },
      {
          id:11,
          toggle:false,
          allergen:false,
          name: "Chili pepper",
          icon_name:"aji",
          description: "chili pepper",
          derivatives:[
              {name:'All varieties of chili.'},
              ],
          exception:null,
      },
      {
      id:12,
      toggle:false,
      allergen:false,
      name: "Seaweed",
      icon_name:"algas",
      description: "seaweed",
      derivatives:[
          {name:'All varieties of Seaweed.'},
          ],
      exception:null,
      },
      {
          id:13,
          toggle:false,
          allergen:false,
          name: "Coconut milk",
          icon_name:"leche-coco",
          description: "coconut milk",
          derivatives:[
              {name:'All varieties of coconut milks.'},
              ],
          exception:null,
      },
    ],
    v_success:false,
    v_photo:0,
    v_loading:true,
  
  },
  getters: {

    getters_en(state){
      return state.v_categories.filter((category)=>category.lang === 'en' && category.menu && category.enabled);
    },
    getters_es(state){
      return state.v_categories.filter((category)=>category.lang === 'es' && category.menu && category.enabled);
    },

    getters_allergens_es(state){
      return state.v_allergens_es;
    },

    getters_allergens_en(state){
      return state.v_allergens_en;
    }


  },
  mutations: {
    V_CATEGORIES(state,data_categories){
      state.v_categories = data_categories;
      state.v_success = true;
      state.v_loading = false;
    }
  },
  actions: {
    v_action_categories({commit,state}){
        state.v_loading = true;
        let config = {
            headers: {
            'Accept':'application/json'
            
            }
        }
        return axios.get(state.v_url_global+'/index-admin-categories',config)
        .then(response => commit('V_CATEGORIES',response.data))
        .catch(e => {
            console.log('error'+e)
            state.v_loading = false;
        });
    }
  },
  modules: {
    login,
    nic,
  }
})
